module.exports = __webpack_public_path__ + "img/yesuan.7afd64a8.jpg";